import styled from '@emotion/styled';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

export const CounterpartSelectForm = ({ onSubmit, onBack }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setResults([]);
      return undefined;
    }

    const timer = setTimeout(() => {
      setLoading(true);
      axiosClient
        .get('ThirdParty/HakaranSystem/Rahkaran/CounterpartContracts', {
          params: {
            StartIndex: 0,
            RecordCount: 4,
            FilterQuery: searchTerm,
          },
        })
        .then(res => {
          if (res.status === 200) {
            setResults(res.data?.value ?? []);
          } else {
            enqueueSnackbar(res?.message, { variant: 'error' });
          }
        })
        .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
        .finally(() => setLoading(false));
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm, enqueueSnackbar]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        pt: 1,
        minWidth: 300,
      }}
    >
      <FormControl variant="standard" sx={{ minWidth: 280 }}>
        <TextField
          autoFocus
          label="جستجو"
          variant="standard"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </FormControl>

      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            width: '100%',
            maxHeight: 240,
            overflowY: 'auto',
          }}
        >
          {results.map(item => (
            <OptionButton
              key={item.key}
              fullWidth
              onClick={() =>
                onSubmit?.({
                  counterpartID: Number.parseInt(item.key, 10),
                })
              }
            >
              {item.value}
            </OptionButton>
          ))}
          {searchTerm.trim() && !results.length ? (
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
            >
              موردی یافت نشد
            </Typography>
          ) : null}
        </Box>
      )}

      {onBack ? (
        <Button onClick={onBack} variant="contained" sx={{ mt: 1 }}>
          بازگشت
        </Button>
      ) : null}
    </Box>
  );
};

const OptionButton = styled(Button)`
  background-color: #e8e8e8;
  color: #333;
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 500;
  box-shadow: none;

  &:hover {
    background-color: #dcdcdc;
    box-shadow: none;
  }
`;
